import request from "@/utils/request";
import {exportFile} from "@/api/common";

const PREFIX_URL = process.env.NODE_ENV === 'development' ? '' : ''

// 财务利润报表
export function getFinanceProfitReportMonth(params) {
  return request.post('/finance/financialProfitAnalysis/monthList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function exportFinanceProfitReportMonth(params) {
  exportFile('/finance/financialProfitAnalysis/exportMonthReport', params)
}

export function getFinanceAnalysisPage(params) {
  return request.post('/finance/financialProfitAnalysis/financialAnalysisList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function exportProfitAnalysis(params) {
  exportFile('/finance/financialProfitAnalysis/exportProfitAnalysis', params)
}

export function getFinanceProfitReportSettlement(params) {
  return request.post('/finance/financialProfitAnalysis/detailsList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function financeProfitTaskPage(params) {
  return request.post('/finance/taskProgressMonitoring/page', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function getAllProgressCount() {
  return request.get('/finance/taskProgressMonitoring/getProgressingCount')
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function recalculateFinanceProfitReport(params) {
  return request.post(`/finance/financialProfitAnalysis/recalculatioFunction?startDate=${params.startDate}&endDate=${params.endDate}&marketIds=${params.marketIds}`)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}


/**
 * 导入站点维度其他费用
 * importMarketExcel
 * @param attId
 * @param feeMonth
 * @param feeWay
 */
export function importMarketExcel(attId, feeMonth, feeWay) {
  return request.post(`/finance/financialFeeItemUseDetail/importMarketExcel?attachmentId=${attId}&feeMonth=${feeMonth}&feeWay=${feeWay}`)
    .then((res) => {
      return Promise.resolve(res)
    })
}

/**
 * 导入MSKU维度其他费用
 * importMskuExcel
 * @param attId
 * @param feeMonth
 * @param feeWay
 */
export function importMskuExcel(attId, feeMonth, feeWay) {
  return request.post(`/finance/financialFeeItemUseDetail/importMskuExcel?attachmentId=${attId}&feeMonth=${feeMonth}&feeWay=${feeWay}`)
    .then((res) => {
      return Promise.resolve(res)
    })
}
/**
 * 添加或者修改费用项管理
 * addOrUpdateFeeItem
 * @param params
 */
export function addOrUpdateFeeItem(params) {
  return request.post('/finance/financialFeeItem/addOrUpdateFeeItem', params)
    .then((res) => {
      return Promise.resolve(res)
    })
}
/**
 * 查询所有费用项
 * queryFeeItemList
 * @param params
 */
export function queryFeeItemList(params) {
  return request.get('/finance/financialFeeItem/queryFeeItemList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}
/**
 * 删除费用项
 * deleteFeeItem
 * @param params
 */
export function deleteFeeItem(params) {
  return request.delete('/finance/financialFeeItem/delete', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}
/**
 * 更新自定义费用项数据
 * deleteFeeItem
 * @param params
 */
export function updateFeeItem(params) {
  return request.put('/finance/financialFeeItemUseDetail/updateFeePrice', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function exportFinanceProfitReportSettlement(params) {
  exportFile('/finance/financialProfitAnalysis/exportDateRange', params)
}

export function getSettlementFeeType() {
  return request.get('/finance/financialProfitAnalysis/feeTypeBox')
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function dateRangeReportLogPage(params) {
  return request.post('/finance/dateRangeReportsLog/page', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function undoImport(id) {
  return request.get(`/finance/dateRangeReportsLog/revokeDateRangeReport/${id}`)
    .then((res) => {
      return Promise.resolve(res)
    });
}

export function importRangeReport(params) {
  return request.post(`/finance/financialProfitAnalysis/import`, params)
    .then((res) => {
      return Promise.resolve(res)
    })
}

// 获取合计
export function analysisStatistics(params) {
  return request.post(`/finance/financialProfitAnalysis/analysisStatistics`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

// 成本中心
export function getCostCenter(params) {
  return request.post('/finance/financialMonthCost/pageSkuList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

//  成本中心 FBA主页面查询
export const getFbaMonthCostPage = params => {
    return request.post(`/finance/financialMonthCost/fbaMonthCostPage`, params).then(res => res.data)
}

//  成本中心 历史查询
export const getHistoryMonthCostPage = params => {
    return request.post(`/finance/financialMonthCost/historyMonthCostPage`, params).then(res => res.data)
}

//  成本中心 -自营仓 -单条修改
export function UpdateMonthCost(params) {
    return request.put('/finance/financialMonthCost/UpdateMonthCost', params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}

//  成本中心 -自营仓 - 批量修改
export function batchUpdateMonthCost(params) {
    return request.put('/finance/financialMonthCost/batchUpdateMonthCost', params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
//  成本中心 -fba仓 - 单个、批量修改
export function batchUpdateFBAMonthCost(params) {
    return request.put('/finance/financialMonthCost/batchUpdateFBAMonthCost', params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}

//  成本中心 自营仓主页面查询
export const getSelfMonthCostPage = params => {
    return request.post(`/finance/financialMonthCost/selfMonthCostPage`, params).then(res => res.data)
}

// 成本中心-导入-国家
export function queryAllCountry() {
    return request.get('/finance/financialMonthCost/queryAllCountry')
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
// 成本中心-导入-店铺
export function queryMarketByCountryCode(params) {
    return request.post('/finance/financialMonthCost/queryMarketByCountryCode', params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}

export function getCostCenterChild(params) {
  return request.get('/finance/financialMonthCost/skuSubList', {params})
    .then((res) => {
      return Promise.resolve(res.data)
    })
}


export function updatePurchaseCost(params) {
  return request.put('/finance/financialMonthCost/updatePurchaseCost', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function updateInventoryCost(params) {
  return request.put('/finance/financialMonthCost/updateInventoryCost', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function exportCostCenter(params) {
  exportFile('/finance/financialMonthCost/export', params)
}

export function importCostCenter(params) {
  return request.post(`/finance/financialMonthCost/import?`+params)
    .then((res) => {
      return Promise.resolve(res)
    })

}

// 回款记录
export function getRemittanceRecord(params) {
  return request.post('/finance/financialPayBack/selectList', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function updateRemittanceRecordMemo(params) {
  return request.put('/finance/financialPayBack/updateMemoById', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function getRemittanceRecordSumMoney(params) {
  return request.post('/finance/financialPayBack/sumMoney', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

/**
 * 查询费用均摊列表
 * @param params
 * @returns {Promise<unknown>}
 */
export function postFeeShareList(params) {
  return request.post(`${PREFIX_URL}/finance/feeManualShare/queryFeeShareList`, params)
    .then(res => res.data)
}

/**
 * 费用分摊提交
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postSaveFeeShare(params) {
  return request.post(`${PREFIX_URL}/finance/feeManualShare/saveFeeShare`, params)
    .then(res => res.data)
}

/**
 * 分摊详情查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postFeeShareDetail(params) {
  return request.post(`${PREFIX_URL}/finance/feeManualShare/queryFeeShareDetails`, params)
    .then(res => res.data)
}


/**
 * 分摊ASIN列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getFeeShareAsin(params) {
  return request.post(`${PREFIX_URL}/finance/feeManualShare/chooseAsin`, params)
    .then(res => res.data)
}

/**
 * 全部费用下拉框
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getFeeAllOptions(params) {
  return request.get(`${PREFIX_URL}/finance/feeManualShare/feeAllCombobox`, {params})
    .then(res => res.data)
}

/**
 * 获取FBA成本批次分页查询-表格
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchPage = params => {
  return request.post(`/supply/storageCostBatch/page`, params).then(res => res.data)
}

/**
 * 初始化批次成本
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchInitSystemBatch = params => {
  return request.post(`/supply/storageCostBatch/initSystemBatch`, params).then(res => res.data)
}

/**
 * 重算进度列表查询
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchRecalculateTaskPage = params => {
  return request.post(`/supply/storageCostBatch/recalculateTask/page`, params).then(res => res.data)
}

/**
 * 重算任务数查询
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchRecalculateNum = params => {
  return request.get(`/supply/storageCostBatch/recalculateTask/num`, params).then(res => res.data)
}

/**
 * 重置成本
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatch = params => {
  return request.put(`/supply/storageCostBatch`, params).then(res => {return Promise.resolve(res.data)})
}

/**
 * 重置成本-添加批次列表
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchAddBatchPage = params => {
  return request.post(`/supply/storageCostBatch/addBatch/page`, params).then(res => res.data)
}

/**
 * 重算-校验重算msku在指定仓库是否存在
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchRecalculateeMskuCheck = params => {
  return request.post(`/supply/storageCostBatch/recalculate/msku/check`, params).then(res => res.data)
}

/**
 * 重算
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchRecalculate = params => {
  return request.post(`/supply/storageCostBatch/recalculate`, params).then((res) => {
    return Promise.resolve(res)
  })
}

/**
 * 分页查询发货补录
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchPageShipSupplement = params => {
  return request.post(`/supply/storageCostBatch/page/ship/supplement`, params)
}

/**
 * 仓库下拉
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchCanRecalculateWarehouse = params => {
  return request.get(`/supply/storageCostBatch/canRecalculateWarehouse/${params}`).then(res => res.data)
}

/**
 * 重算仓库下拉
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const newStorageCostBatchCanRecalculateWarehouse = ()=> {
  return request.get(`/supply/storageCostBatch/canRecalculateWarehouse`).then(res => res.data)
}

/**
 * 导入更新批次成本
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchImport = (params, bodyParams) => {
  return request.post(`/supply/storageCostBatch/import?attachmentId=${params.attachmentId}`, bodyParams).then(res => res)
}

/**
 * 仓库初始化日期
 * 批次管理
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchWarehouseInitDate = params => {
  return request.get(`/supply/storageCostBatch/warehouseInitDate/${ params }`).then(res => res.data)
}

/**
 * 发货补录-导入发货补录信息
 * 扣减记录
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
  export const storageCostBatchImportShipSupplement = params => {
    return request.post(`/supply/storageCostBatch/import/ship/supplement?attachmentId=${params}`).then(res => res)
  }

/**
 * 发货补录-货件号下拉
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchShipmentWarehouseMskuInfo = params => {
  return request.get(`/supply/storageCostBatch/shipment/warehouse/msku/info`, params).then(res => res.data)
}

/**
 * 发货补录-新增发货补录
 * 扣减记录
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchSaveShipSupplement = params => {
  return request.post(`/supply/storageCostBatch/save/ship/supplement`, params).then(res => res.data)
}

/**
 * 发货补录-删除发货补录
 * 扣减记录
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchDeleteShipSupplement = params => {
  return request.delete(`/supply/storageCostBatch/delete/ship/supplement`, { data:params }).then(res => res.data)
}

/**
 * 发货补录-修改发货补录
 * 扣减记录
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const storageCostBatchUpdateShipSupplement = params => {
  return request.put(`/supply/storageCostBatch/update/ship/supplement`, params).then(res => res.data)
}

/**
 * 发货补录-重算
 * 扣减记录
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const supplementRecalculate = params => {
  return request.post(`/supply/storageCostBatch/supplement/recalculate`, params).then(res => res.data)
}

/**
 * 扣减记录分页查询
 * 扣减记录
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
  export const storageCostBatchConsumePage = params => {
    return request.post(`/supply/storageCostBatchConsume/page`, params).then(res => res.data)
  }

/**
 * 业绩报告分页查询
 * 业绩报告
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const queryChargePerformanceReportResultList = params => {
  return request.post(`/finance/financialPerformanceReport/queryChargePerformanceReportResultList`, params).then(res => res.data)
}

/**
 * 业绩报告分页查询
 * 业绩报告
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
 export const getChargePerformanceMonthReportList = params => {
  return request.post(`/finance/financialPerformanceReport/getChargePerformanceMonthReportList`, params).then(res => res.data)
}

//导入分摊费用
export function feeManualShareImport(attId, feeMonth) {
    return request.post(`/finance/feeManualShare/import?attachmentId=${attId}&feeShareMonth=${feeMonth}`)
        .then((res) => {
            return Promise.resolve(res)
        })
}

//获取msku的每日销售额
export function mskuSalesList(params) {
    return request.post(`${PREFIX_URL}/finance/feeManualShare/mskuSalesList`,params)
        .then((res) => {
          return Promise.resolve(res)
        })
}

//保存费用分摊
export function saveFeeShare(params) {
    return request.post(`${PREFIX_URL}/finance/feeManualShare/saveFeeShare`,params)
        .then((res) => {
          return Promise.resolve(res)
        })
}

//1.10.2-添加发货补录分页查询
export function addShipSupplement(params) {
  return request.post(`${PREFIX_URL}/supply/storageCostBatch/page/add/ship/supplement`,params)
      .then((res) => {
        return Promise.resolve(res.data)
      })
}

//1.10.2-获取货件下拉，状态为CLOSED 状态
export function selectBoxShipment() {
  return request.get(`${PREFIX_URL}/supply/storageCostBatch/shipment/select/box`)
      .then((res) => {
        return Promise.resolve(res.data)
      })
}

//1.10.2-获取货件下拉，状态为CLOSED 状态
export function supplementHistory(params) {
  return request.post(`${PREFIX_URL}/supply/storageCostBatch/list/supplement/history`,params)
      .then((res) => {
        return Promise.resolve(res.data)
      })
}

//1.10.2-新增或修改或删除发货补录信息
export function saveOrUpdateOrDelete(params) {
  return request.post(`${PREFIX_URL}/supply/storageCostBatch/supplement/saveOrUpdateOrDelete`,params)
      .then((res) => {
        return Promise.resolve(res.data)
      })
}